export const LUPP_BASE_URL = import.meta.env.VITE_LUPP_BASE_URL;

export const LUPP_QUERY_KEYS = {
  LEADS: 'lupp-leads',
  PROSPECTS: 'lupp-prospects',
  PROSPECT_METRICS: 'lupp-prospect-metrics',
  QUOTES: 'lupp-quotes',
  FHM_ALERTS: 'lupp-fhm-alerts',
  FHM_ALERT_DETAIL: 'lupp-fhm-alert-detail',
  FSE_TECH_SUPPORT_CASES: 'lupp-fse-tech-support-cases',
  CUSTOMER_CASES: 'lupp-customer-cases',
  NOTES: 'lupp-notes',
  PARTNER_USERS: 'lupp-partner-users',
  // FileHub keys
  FILES: 'lupp-files',
  FILE_METADATA: 'lupp-file-metadata',
  FILE_DOWNLOAD: 'lupp-file-download',
  // Inventory keys
  INVENTORY_VEHICLES: 'lupp-inventory-vehicles',
  USER_LOCATION: 'lupp-user-location',
  PR_CODES: 'lupp-pr-codes',
  CHECKOUT_DETAIL: 'lupp-checkout-detail',
  USER_IDENTITY: 'lupp-user-identity',
};
